import { Sizes } from '../../constants';

export const TIMELINE_MARKER = {
  DOT: 'dot',
  NUMBER: 'number',
  ICON: 'icon',
};

export const TIMELINE_SIZE_DEFAULT = Sizes.SMALL;
